// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"0":"81f09a27","202":"d0409d75","274":"8ca5e8a0","473":"a78f8238","480":"fcf2c952"}[chunkId] + ".chunk.js";
};